export type IOTPValidity = {
	isValid: boolean;
	message: string;
};

export const OTPValidityDefault = {
	isValid: true,
	message: '',
};
